const HeadspaceIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 32 32" fill="none" {...props}>
    <circle cx="16" cy="16" r="8" fill="#FF7300"></circle>
  </svg>
);

export { HeadspaceIcon };
